'use client';

import { dataLayerPush, getBaseUrlJoined, layoutEvents } from '@libs/analytics';
import {
    LegacyIcon,
    LegacyIconName,
    useBasketCount,
    useCart,
    useIsExperimentFullSolution,
} from '@libs/common-next';
import { NAVIGATION_URLS } from '@libs/core';
import { Notification } from '@petsmart-ui/sparky';

import './LegacyMinicart.scss';

export const trackingData = (data: object) =>
    Object.assign(data, { ...layoutEvents.headerClick });

export default function LegacyMinicart() {
    const { basketCount } = useBasketCount();
    const { cart } = useCart();
    const isExperimentFullSolution = useIsExperimentFullSolution();

    const ctQty = cart?.summary?.itemCount ?? 0;
    const qty = isExperimentFullSolution ? ctQty : basketCount;

    return (
        <div
            id="mini-cart"
            className="legacy-mini-cart"
            data-testid="legacy-cart-icon"
        >
            <a
                className="legacy-mini-cart__link"
                aria-label="Shopping Cart"
                title="View Cart"
                href={NAVIGATION_URLS.legacy.cart}
                onClick={() =>
                    dataLayerPush(
                        trackingData({
                            selection: 'cart',
                            link_url: getBaseUrlJoined(
                                NAVIGATION_URLS.legacy.cart
                            ),
                        })
                    )
                }
            >
                <LegacyIcon
                    className="legacy-mini-cart__icon"
                    aria-hidden="true"
                    focusable={false}
                    name={LegacyIconName.CART}
                    priority
                    size={26}
                />
                {qty ? (
                    <Notification
                        data-testid="notification"
                        className="legacy-mini-cart__notification"
                        text={qty}
                        screenReaderText={`${qty} items in your cart`}
                    />
                ) : null}
            </a>
        </div>
    );
}
